/**
 * Business plane auth UX — legacy JWT re-login · API 403 handling (FG-14)
 */

import { PORTAL_ENTRY_PATH } from '@shared/tenant-host';
import { clearStoredAuth, getCurrentTokenPayload } from '../utils/jwtUtils';

export const BUSINESS_PLANE_BLOCKED_CODE = 'BUSINESS_PLANE_BLOCKED';

export const LEGACY_JWT_RELOGIN_MESSAGE =
  '세션이 만료되었습니다. entityType이 포함된 새 토큰을 받으려면 다시 로그인해 주세요.';

export type BusinessPlaneBlockReason = 'legacy_jwt' | 'external_entity';

export function isLegacyJwtWithoutEntityType(): boolean {
  const payload = getCurrentTokenPayload();
  return payload !== null && payload.entityType === undefined;
}

export function resolveBusinessPlaneBlockReason(): BusinessPlaneBlockReason {
  const payload = getCurrentTokenPayload();
  if (payload?.entityType === 'external') return 'external_entity';
  return 'legacy_jwt';
}

export function clearAuthAndRedirectForBusinessPlaneBlock(
  reason: BusinessPlaneBlockReason = resolveBusinessPlaneBlockReason()
): void {
  if (typeof window === 'undefined') return;

  if (reason === 'legacy_jwt') {
    clearStoredAuth();
    if (!window.location.pathname.startsWith('/login')) {
      window.location.assign('/login?reason=legacy_jwt');
    }
    return;
  }

  if (window.location.pathname !== PORTAL_ENTRY_PATH) {
    window.location.assign(`${PORTAL_ENTRY_PATH}?businessPlaneBlocked=1`);
  }
}
